export const warehousesIds ={
    oficina_venta_rp: 3,
    rodriguez_penia: 15,
    san_martin: 16,
    deposito_rp: 17,
    deposito_sm: 18,
    oficina_venta_sm: 19,
}
